import { Box, styled } from '@mui/material';

export const ReleasesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const ReleasesNavbarContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

interface StyledProps {
  isMiniPlayerVisible?: boolean;
}

export const OutletContainer = styled(Box)<StyledProps>(
  ({ theme, isMiniPlayerVisible }) => ({
    display: 'grid',
    paddingBottom: isMiniPlayerVisible ? theme.spacing(12.5) : theme.spacing(2),
  })
);
